<template lang='pug'>
    v-container#wizard(tag="section" style="position:relative;" :style="isMobile ? 'min-height: 100%' : ''" :fullscreen="isMobile").pa-0.ma-0
      v-dialog(max-width='380'  origin  v-model="loginDialog")
        login(userType="customer"  @close="loginDialog = false" @switchDialog="switchDialog('register')" style="z-index: 9999;")
      v-dialog(  origin  v-model="registerDialog")
        register(userType="customer"  @close="registerDialog = false" @switchDialog="switchDialog('login')" style="z-index: 9999;")
      v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true" style="z-index: 9999;")
        | {{ snackbar.text }}
        v-btn(dark='' text='' @click='snackbar.snackbar = false')
          | {{$t('payment.general.close')}}
      v-btn(fab small color="primary" @click="$emit('closePayment')" style="position: absolute; z-index: 999; top: 10px; right: 0px;")
          v-icon.primary.rounded mdi-close
      validation-observer(v-slot="{ valid }")
        base-material-wizard.mx-auto(title='Confirmar pedido' subtitle='Confirma y haz tu pedido en linea' v-model="tab" :loading="loading" :available-steps="availableSteps" :items="tabs" @click:next="next(valid)" @click:prev="tab--")
          v-tab-item.pb-12
            // cart
            BasketModal(@valid="validAmounts = $event" @getcart="getDataCart" :currentShopId="'-M-qrlBJUbDgQc1lbYzW'") <!-- se cambio a ordermodal por eso el currentShopid esta estatico -->
          v-tab-item.pb-12
            // Payment
            form
              v-responsive.mx-auto(max-width="500")
                .text-center.display-1.grey--text.font-weight-light.mb-6
                  | ¿Con que medio de pago deseas realizar la compra?
                validation-provider(v-slot="{ errors }" rules="required" name="type")
                  input(:value="stringAccount" type="hidden")
                v-item-group.row(v-model="account" multiple="")
                  v-item(v-for="(account, i) in accounts" :key="i")
                    template(v-slot="{ active, toggle }")
                      v-col.text-center(cols="6" md="4" @click="mercadoPagoCheckOut(account)")
                        v-card.mb-6.mx-auto.pa-10.d-inline-block.v-card--account( :class="active ? 'success--text' : 'grey--text'" outlined="" @click="toggle")
                          v-icon(large="" v-text="account.icon")
                        .text-uppercase.subtitle-2.text--primary(v-text="account.type")
          v-tab-item.pb-12
            // delivery options
            form
              v-responsive.mx-auto(max-width="500")
                .text-center.display-1.grey--text.font-weight-light.mb-6
                  | ¿Como deseas recibir tu pedido?
                v-col(v-for="(location, i) in cart")
                  v-row.justify-center
                    p {{location.name}}
                  v-item-group
                    v-container
                      v-row
                        v-col(v-for="(delivery, i) in deliveryOptions" :key="i" cols="6")
                          v-item(v-slot="{ active, toggle }")
                            div
                              v-card.v-card--account.pa-8.mb-6.d-flex.align-center(:class="active ? 'success--text' : 'grey--text'" outlined="" height="180" @click="setDeliveryOption(location, i, active)" v-on:click="toggle" )
                                v-img(:src="delivery.icon")
                              .text-uppercase.subtitle-2.text--primary.text-center(v-text="delivery.type")
          v-tab-item.pb-12
            // Direction
            form
              v-responsive.mx-auto(max-width="500")
                .text-center.display-1.grey--text.font-weight-light.mb-6(v-if="atLeastOneDelivery")
                  | ¿En donde deseas recibir el pedido?
                v-col(cols="12" v-if="atLeastOneDelivery")
                  p(v-if="disbaledAutGoogle") Dirección
                  gmap-autocomplete(@place_changed="setPlace" v-if="disbaledAutGoogle" :options="autocompleteOptions" class="border-location input--google" validate-on-blur="" placeholder="Introduce tu dirección").location-input
                  v-row.justify-center.pa-3()
                    p Mis direcciones:
                  v-row.justify-center.pa-3()
                    v-chip-group(v-model="selectedChip" column active-class="primary--text")
                      v-chip.mr-2(@click="gpsAddress.direction ? setAddress(gpsAddress) : ''" :style="gpsAddress.direction ? '': 'pointer-events: none'")
                        img(src="@/assets/images/location-icon.png")
                        span.ml-2.video-card__location(v-if="gpsAddress.direction") {{gpsAddress.direction}}
                        span.ml-2.video-card__location(v-else) No podemos acceder a tu ubicación
                      v-chip(v-for="location in userLocations" @click="setAddress(location)" :key="location.direction")
                        | {{ location.direction }}
                v-col.justify-center.pa-4(v-if="atLeastOnePickup")
                  v-row.mb-2()
                    p Direcciones de los establecimientos en los que buscaras tus productos:
                  v-row.mb-2(v-for="(location, i) in cart")
                    p(v-if="location.delivery === 'pickup'") {{location.name + ':   ' + location.addressInfo.addressgoogle}}
                  v-row.justify-center(v-if="!atLeastOnePickup")
                    p No aplica
          v-tab-item.pb-12
            // Confirmation
            form
              v-row.d-flex.justify-space-between
                .text-center.display-1.font-weight-light.col-6
                  |Metodo de pago
                b.text-center.col-6 Efectivo
                .text-center.display-1.font-weight-light.col-6
                  |Direccion de entrega
                b.text-center.col-6 {{address}}
              div(v-for='(cart, i) in arrCart' :key='i' cols='12')
                p(class="shop-title") {{cart.name}}
                p(style="padding: 10px; font-size: 15px") Opción de entrega: {{cart.delivery && cart.delivery.includes('delivery') ? 'Domicilio' : 'Buscar en el establecimiento'}}
                p(v-if="cart.deliveryCost === -1" style="padding: 10px; font-size: 15px") {{'Direccion: ' + cart.addressInfo.addressgoogle}}
                p(v-else style="padding: 10px; font-size: 15px") {{'Costo del domicilio: ' + cart.deliveryCost}}
                p(style="padding: 10px; font-size: 15px") {{'Total: ' + cart.subtotal}}
                v-row.mx-auto(justify="space-around" style="max-width: 500px;")
                  v-col
                    .text-center.display-1.font-weight-light.mb-6
                      | Verifica tu Orden
                    v-row
                      v-col(cols="2" style="padding: 0px 0px 10px 10px;")
                        | Imagen
                      v-col(cols="7" style="padding: 0px 0px 10px 10px;")
                        | Nombre
                      v-col(cols="3" style="padding: 0px 0px 10px 10px;")
                        | Cantidad
                v-col(v-for='(product, j) in cart.inventory' :key='j' cols='12' v-if="product")
                  v-row
                    v-col(cols="2" style="padding: 0px 0px 10px 10px;")
                      v-img(style="width: 50px; height: 50px;" :src='product.data.pictures.imageInput1 != "" ? product.data.pictures.imageInput1 : "https://cdn.vuetifyjs.com/images/cards/docks.jpg"')
                    v-col(cols="7" style="padding: 0px 0px 10px 10px;")
                      p(style="padding-left: 25px;     margin-bottom: 0px;") {{product.data.name}}
                      p(style="padding-left: 25px;     margin-bottom: 0px;") $ {{product.data.price.sale}}
                    v-col(cols="3" style="padding: 0px 0px 10px 10px;")
                      v-row
                        p(style="padding: 2px; padding-top: 10px; margin-bottom: 0px;") {{product.amount}}
                    hr(style="width: 100%;")
</template>

<script>
  import BasketModal from '@/views/marketplace/components/BasketModal'
  import Swal from 'sweetalert2'
  import Vue from 'vue'
  import * as vars from '@/vars.json'
  import axios from 'axios'
  const geocoding = require('reverse-geocoding-google')

  export default {
    name: 'DashboardFormsWizard',
    components: {
      BasketModal: BasketModal,
      login: () => import('@/views/pages/Login'),
      register: () => import('@/views/pages/Register'),
    },
    data: () => ({
      account: [],
      paymentMethod: null,
      selectedChip: '',
      validAmounts: true,
      allAboveMinimum: true,
      gpsAddress: {},
      validDeliveryStep: false,
      disbaledAutGoogle: true,
      autocompleteOptions: {
        componentRestrictions: {
          country: [
            'co',
          ],
        },
      },
      accounts: [
        {
          icon: 'mdi-cash',
          type: 'Efectivo',
        },
        {
          icon: 'mdi-cash',
          type: 'Mercado pago',
        },
      ],
      deliveryOptions: [
        {
          icon: require('@/assets/icons/delivery/delivery-man.png'),
          type: 'Domicilio',
        },
        {
          icon: require('@/assets/icons/delivery/shop.png'),
          type: 'Buscar en el establecimiento',
        },
      ],
      snackbar: {
        color: '',
        snackbar: false,
        text: '',
        timeout: 6000,
      },
      loading: false,
      address: '',
      arrCart: [],
      totalPrice: 0,
      ordersSize: 0,
      allOrdersSent: 0,
      loginDialog: false,
      registerDialog: false,
      atLeastOnePickup: false,
      atLeastOneDelivery: false,
      selectedLat: 0,
      selectedLng: 0,
      city: '',
      email: '',
      first: '',
      image: null,
      last: '',
      state: '',
      street: '',
      tab: 0,
      tabs: ['Canasta', 'Metodo de pago', 'Opción de entrega', 'Dirección de envio', 'Confirmar orden'],
    }),

    computed: {
      userProfile () {
        const vm = this
        return vm.$store.getters['users/getProfile']
      },
      userLocations () {
        const vm = this
        if (vm.userProfile) {
          const locations = vm.userProfile.locations
          const locationsText = []
          if (locations) {
            for (const key in locations) {
              if (Object.prototype.hasOwnProperty.call(locations, key)) {
                const location = locations[key]
                locationsText.push(location)
              }
            }
            return locationsText
          } else if (vm.userProfile.defaultlocation) {
            locationsText.push(vm.userProfile.defaultlocation)
            return locationsText
          } else {
            return []
          }
        } else {
          return []
        }
      },
      coupon () {
        const vm = this
        return vm.$store.getters['promotions/getCoupon']
      },
      stringAccount () {
        const vm = this
        return vm.account.join(',')
      },
      scope () {
        const vm = this
        if (vm.tab === 0) return 'Metodo de pago'
        else if (vm.tab === 1) return 'Confirmar orden'
        return 'Metodo de pago'
      },
      cart () {
        const vm = this
        return vm.$store.getters['pos/getCart']
      },
      availableSteps () {
        const vm = this
        const steps = [0]
        if (
          vm.cart.length > 0 &&
          vm.validAmounts &&
          vm.allAboveMinimum
        ) steps.push(1)

        if (
          vm.account.length > 0
        ) steps.push(2)

        if (
          vm.validDeliveryStep
        ) steps.push(3)

        if (
          vm.address &&
          steps.includes(3)
        ) steps.push(4)

        return steps
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    watch: {
      selectedChip (newVal, oldVal) {
        const vm = this
        // console.log(newVal)
        if (newVal >= 0) {
          vm.disbaledAutGoogle = false
        } else {
          vm.address = ''
          vm.disbaledAutGoogle = true
        }
      },
    },
    created () {
      const vm = this
      vm.geolocate()
    },
    /* mounted () {
      const vm = this
      vm.getDataCart()
    }, */
    methods: {
      mercadoPagoCheckOut (account) {
        const vm = this
        // console.log(account)
        if (account.type === 'Mercado pago') {
          // console.log('entre', vm.cart)
          axios.post(vars.url + '/checkoutMercadoPago', { items: vm.cart[0].inventory, ownerId: vm.cart[0].uid }).then(res => {
            // console.log(res.data, 'termine checkout')
            window.location.replace(res.data)
            /* const mpScript = document.createElement('script')
            mpScript.setAttribute('src', 'https://www.mercadopago.com.co/integrations/v1/web-payment-checkout.js')
            mpScript.setAttribute('data-preference-id', res.data)
            document.head.appendChild(mpScript) */
          }).catch(error => {
            console.log(error, 'error mercado pago')
          })
        }
      },
      setPlace (place) {
        const vm = this
        vm.address = place.formatted_address
        vm.selectedLat = place.geometry.location.lat()
        vm.selectedLng = place.geometry.location.lng()
      },
      showShopsOrClientAddress () {
        const vm = this
        vm.atLeastOneDelivery = false
        vm.cart.forEach(location => {
          if (location.delivery === 'delivery') {
            vm.atLeastOneDelivery = true
          }
        })

        vm.atLeastOnePickup = false
        vm.cart.forEach(location => {
          if (location.delivery === 'pickup') {
            vm.atLeastOnePickup = true
          }
        })
      },
      allOrdersHaveDeliveryOption () {
        const vm = this
        vm.validDeliveryStep = true
        vm.cart.forEach(location => {
          // console.log(location)
          if (!location.delivery) {
            vm.validDeliveryStep = false
          }
        })
        return vm.validDeliveryStep
      },
      setDeliveryOption (location, type, active) {
        const vm = this
        // console.log(location)
        if (type === 0 && !active) {
          location.delivery = 'delivery'
        } else if (type === 1 && !active) {
          location.delivery = 'pickup'
        } else {
          location.delivery = ''
        }
        vm.allOrdersHaveDeliveryOption()
      },
      switchDialog (to) {
        const vm = this
        switch (to) {
          case 'login':
            vm.registerDialog = false
            vm.loginDialog = true
            break
          case 'register':
            vm.loginDialog = false
            vm.registerDialog = true
            break
        }
      },
      setAddress (location) {
        const vm = this
        // console.log(location)
        vm.address = location.direction
        vm.selectedLng = location.location.lng
        vm.selectedLat = location.location.lat
      },
      finishSendOrder () {
        const vm = this
        vm.ordersSize = vm.arrCart.length
        vm.allOrdersSent = 0
        for (let i = 0; i < vm.arrCart.length; i++) {
          vm.sendOrder(vm.arrCart[i])
        }
      },
      next (valid) {
        const vm = this
        if (vm.tab === 0 && (vm.cart.length === 0 || !vm.validAmounts || !vm.allAboveMinimum)) {
          return
        } else if (vm.tab === 0) {
          valid = true
        }

        if (vm.tab === 2 && !vm.validDeliveryStep) {
          return
        } else if (vm.tab === 2) {
          valid = true
          vm.showShopsOrClientAddress()
        }

        if (vm.tab === 3 && !vm.atLeastOneDelivery) {
          vm.address = 'No registra'
          valid = true
        }

        if (!valid) return

        if (vm.tab === 0 && !vm.userProfile) {
          vm.loginDialog = true
        } else if (vm.tab === vm.tabs.length - 1) {
          vm.finishSendOrder()
        } else if (vm.tab === 3 && (vm.address !== '' || !vm.atLeastOneDelivery)) {
          const cartSize = vm.cart.length
          let cont = 0
          vm.loading = true
          // console.log(vm.cart)
          vm.cart.forEach(location => {
            /* if (location.delivery === 'delivery') {
              const info = {
                latInicial: location.addressInfo.lat.toString(),
                lgnInicial: location.addressInfo.lng.toString(),
                dirInicial: location.addressInfo.addressgoogle,
                latFinal: vm.selectedLat.toString(),
                lgnFinal: vm.selectedLng.toString(),
                dirDestino: vm.address,
                idaRegreso: 'NO',
              }

              vm.$store.dispatch('delivery/deliveryCost', info).then((res) => {
                if (res.success) {
                  location.deliveryCost = res.costo
                  cont++
                  if (cont === cartSize) {
                    vm.getDataCart()
                    vm.loading = false
                    vm.tab++
                  }
                }
              })
            } else { */
            location.deliveryCost = -1
            cont++
            if (cont === cartSize) {
              vm.getDataCart()
              vm.loading = false
              vm.tab++
            }
            // }
          })
        } else if (vm.tab === 3 && vm.address === '') {
          // es invalido y no se hace nada
        } else {
          vm.tab++
        }
      },
      onChange (val) {
        const vm = this
        const value = val.target.files[0]

        if (!value) return (vm.image = null)

        vm.image = URL.createObjectURL(value)
      },
      setDataNotification (ban, color, text) {
        const vm = this
        vm.snackbar.snackbar = ban
        vm.snackbar.color = color
        vm.snackbar.text = text
      },
      getDataCart () {
        const vm = this
        vm.arrCart = vm.cart
        // console.log('cart ', vm.arrCart)
        vm.totalPrice = 0
        for (let i = 0; i < vm.arrCart.length; i++) {
          vm.arrCart[i].subtotal = 0 // agregado solo para la confirmacion de la orden
          for (let j = 0; j < vm.arrCart[i].inventory.length; j++) {
            vm.arrCart[i].subtotal = (parseFloat(vm.arrCart[i].subtotal) + (parseFloat(vm.arrCart[i].inventory[j].data.price.sale)) * (parseFloat(vm.arrCart[i].inventory[j].amount))).toFixed(2)
          }
          // console.log(vm.arrCart[i].subtotal)
          vm.totalPrice += +vm.arrCart[i].subtotal
        }
        if (vm.coupon !== null) {
          if (vm.coupon.isPorcentual) {
            vm.totalPrice = (vm.totalPrice * (100 - vm.coupon.value)) / 100
          } else {
            vm.totalPrice = vm.totalPrice - vm.coupon.value
            if (vm.totalPrice < 0) {
              vm.totalPrice = 0
            }
          }
        }
        vm.allOrdersAboveMinimumValue()
      },
      sendOrder (cart) {
        const vm = this
        vm.loading = true
        const arrItems = []
        let totalPrice = 0
        for (let i = 0; i < cart.inventory.length; i++) {
          arrItems.push({
            amount: cart.inventory[i].amount,
            discount: '',
            id: cart.inventory[i].data.id,
            name: cart.inventory[i].data.name,
            ingredients: cart.inventory[i].data.ingredients || [],
            price: cart.inventory[i].data.price.sale,
            magnitude: cart.inventory[i].data.magnitude,
            unit: cart.inventory[i].data.unit,
            pricewithouttax: cart.inventory[i].data.price.salewithouttax || 0,
            purchase: cart.inventory[i].data.price.buy,
            pictures: cart.inventory[i].data.pictures,
            total: parseFloat(parseFloat(cart.inventory[i].amount) * parseFloat(cart.inventory[i].data.price.sale)).toFixed(2),
            type: cart.inventory[i].data.type,
          })
          totalPrice = totalPrice + parseFloat(parseFloat(cart.inventory[i].amount) * parseFloat(cart.inventory[i].data.price.sale))
        }
        if (vm.coupon !== null) {
          if (cart.id === vm.coupon.availableShop) {
            if (vm.coupon.isPorcentual) {
              totalPrice = (totalPrice * (100 - vm.coupon.value)) / 100
            } else {
              totalPrice = totalPrice - vm.coupon.value
              if (totalPrice < 0) {
                totalPrice = 0
              }
            }
          }
        }
        const referenceNumber = Vue.moment().valueOf()
        const time = Vue.moment().format()
        const cash = totalPrice.toFixed(2)

        const directionOrder = {
          direction: vm.address,
          location: {
            lat: +vm.selectedLat,
            lng: +vm.selectedLng,
          },
        }
        const data = {
          uid: cart.uid,
          data: {
            cash: cash,
            cashback: 0,
            id: '',
            items: arrItems,
            location_from: {
              id: cart.id,
              name: cart.name,
              pictures: cart.pictures,
              addressInfo: cart.addressInfo,
            },
            client: {
              direction: cart.delivery === 'delivery' ? directionOrder : 'No registra',
            },
            delivery: cart.delivery,
            reference_number: referenceNumber,
            referral: vm.referral,
            time: time,
            total: totalPrice.toFixed(2),
            type: 'orders',
            status: 'pending',
            origin: 'VIRTUAL-SHOP',
          },
        }
        // console.log(data, cart)
        // AQUI DEBO CAMBIAR EL ESTADO DEL CUPON
        if (vm.coupon) {
          if (data.data.location_from.id === vm.coupon.availableShop) {
            data.data.coupon = vm.coupon
            vm.$store.dispatch('promotions/changeStateCoupon', vm.coupon.id).then(() => {
              vm.$store.dispatch('promotions/deleteCoupon')
            })
          } else {
            Swal.fire({
              title: `El cupón que seleccionaste no esta disponible para 
                    la tienda ${data.data.location_from.name}`,
              text: '¿Desea continuar con esta orden?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Si, continuar',
              cancelButtonText: 'No',
            }).then((result) => {
              if (result.value) {
                vm.$store.dispatch('pos/sendOrder', data).then(() => {
                  vm.allOrdersSent = vm.allOrdersSent + 1
                  vm.$store.dispatch('pos/removeOrder', cart).then(() => {
                    vm.getDataCart()
                    if (vm.allOrdersSent === vm.ordersSize) {
                      vm.setDataNotification(true, 'success', 'Orden procesada.')
                      vm.loading = false
                      vm.$emit('closePayment')
                    }
                  })
                })
              }
            })
          }
        } else {
          vm.$store.dispatch('pos/sendOrder', data).then(() => {
            vm.allOrdersSent = vm.allOrdersSent + 1
            vm.$store.dispatch('pos/removeOrder', cart).then(() => {
              vm.getDataCart()
              if (vm.allOrdersSent === vm.ordersSize) {
                Swal.fire({
                  icon: 'success',
                  title: 'Tu pedido ha sido enviado!',
                  showCancelButton: true,
                  confirmButtonColor: '#00CAE3',
                  cancelButtonColor: '#A1E5AB',
                  confirmButtonText: 'Ir a mis ordenes',
                  cancelButtonText: 'Seguir comprando',
                }).then((result) => {
                  if (result.value) {
                    vm.$router.replace('/my-requests')
                  }
                })
                vm.loading = false
                vm.$emit('closePayment')
              }
            })
          })
        }

        const clientData = {
          client: {
            direction: vm.$store.state.users.profile.direction.address, // + ' ' + vm.$store.state.users.profile.direction.street,
            email: vm.$store.state.users.user.email,
            identification: vm.$store.state.users.profile.identification,
            name: vm.$store.state.users.profile.name + ' ' + vm.$store.state.users.profile.last_name,
            phone: vm.$store.state.users.profile.phone,
            sendBill: false,
          },
          userId: data.uid,
          context: 'marketplace',
        }
        vm.$store.dispatch('clients/addUpdateClient', clientData)
      },
      geolocate () {
        const vm = this
        navigator.geolocation.getCurrentPosition(position => {
          // console.log(position)
          const latitude = position.coords.latitude
          const longitude = position.coords.longitude
          const config = {
            latitude: latitude,
            longitude: longitude,
            key: vars.googleKey,
          }
          vm.gpsAddress = {
            location: {
              lat: latitude,
              lng: longitude,
            },
            direction: '',
          }
          geocoding.location(config, (err, data) => {
            if (err) {
              // console.log(err)
            } else {
              // console.log(data)
              vm.gpsAddress.direction = data.results[0].formatted_address
            }
          })
        })
      },
      allOrdersAboveMinimumValue () {
        const vm = this
        // console.log('me ejecute')
        vm.allAboveMinimum = true
        for (let i = 0; i < vm.cart.length; i++) {
          const minValue = +vm.cart[i].minOrderValue || 0
          if (+vm.cart[i].subtotal < minValue) {
            vm.allAboveMinimum = false
          }
        }
        // console.log(vm.allAboveMinimum)
        return vm.allAboveMinimum
      },
    },
  }
</script>

<style lang="sass">
  .input--google
    width: 100%
    border-bottom: solid
    border-width: 1px
    border-color: gray
    margin: 0px !important
    height: 30px
    margin-top: 0px !important
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

  #wizard
    margin: 0 !important

  .v-tabs-bar__content
    overflow-x: auto
    overflow-y: hidden
    max-width: 100vw

</style>
